import { css } from 'styled-components';

export var ControlOptionsMenuContainerStyles = css`
	position: absolute;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
`;
